module.exports = __webpack_public_path__ + "f60bdd70ac7373a87a1629bc600cb953.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/group/Black1.jpg
// module id = 6
// module chunks = 0